import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface Props {
    /** Small label rendered above the heading, e.g. "Analytics". Defaults to "Analytics". */
    eyebrow?: string;
    /** Main heading. Defaults to "Analytics". */
    title?: string;
    description?: string;
    /** Rendered top-right of the heading row, e.g. a study switcher. */
    action?: ReactNode;
    className?: string;
}

const AnalyticsPageTitle = ({ eyebrow, title = "Analytics", description, action, className }: Props) => {
    return (
        <div className={cn("flex flex-wrap justify-between items-start gap-4 w-full", className)}>
            <div className="space-y-1 min-w-0">
                {eyebrow && (
                    <p className="font-semibold text-slate-500 dark:text-slate-400 text-xs uppercase tracking-wide">
                        {eyebrow}
                    </p>
                )}
                <h1 className="font-bold text-slate-900 dark:text-slate-100 text-3xl">{title}</h1>
                {description && <p className="text-slate-600 dark:text-slate-400 text-sm">{description}</p>}
            </div>
            {action}
        </div>
    );
};

export default AnalyticsPageTitle;
